import React from "react";
import styles from "./PageBanner.module.css";
//import { Link } from "react-router-dom";
const PageBanner = ({ image, title }) => {
  return (
    <div className={styles.pageBanner}>
      <img src={image} alt={title} className={styles.bannerImg} />
      <div className={styles.bannerOverlay}>
        {/*  {title && <h1 className="banner-title">{title}</h1>}
      {title ? null : (
        <div className="textBlock">
          <h1>Expert Legal Solutions</h1>
          <p>
            Providing trusted legal advice and representation with integrity,
            professionalism, and care.
          </p>
          <Link to="/contact" className="ctaButton">
            Request a Consultation
          </Link>
        </div>
      )}*/}
      </div>
    </div>
  );
};

export default PageBanner;
